// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"19":"127f03fe","212":"cf14716b","234":"d8cd29b9","336":"4beffeb0","453":"7fc2c0f7","474":"f7d03dde","477":"d4e0848e","504":"2e797f61","612":"29d9b232","939":"7f868a20"}[chunkId] + ".chunk.js";
};